import Vue from 'vue';
import './pollyfills';
import VueMoment from 'vue-moment';
import VueNotify from 'vue-notifyjs';
import VeeValidate from 'vee-validate';
import { Select, Option } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
// Axios http requests and set as $http provider globally
import axios from 'axios';
import store from '@/store';
import router from './router/router';
import App from './App.vue';

// Plugins
import GlobalComponents from './globalComponents';
import GlobalDirectives from './globalDirectives';
import SideBar from './components/UIComponents/SidebarPlugin';

// library imports

import './assets/sass/paper-dashboard.scss';
import './assets/sass/element_variables.scss';
import './assets/sass/demo.scss';

import sidebarLinks from './sidebarLinks';

import './registerServiceWorker';

// plugin setup
Vue.use(VueMoment);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar, { sidebarLinks });
Vue.use(VeeValidate);
locale.use(lang);
Vue.use(Option);
Vue.use(Select);

const instance = axios.create();
instance.interceptors.request.use(config => {
  if (store.getters['account/token']) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${store.getters['account/token']}`;
  }
  return config;
});
Vue.prototype.$http = instance; // https://vuejs.org/v2/cookbook/adding-instance-properties.html#Real-World-Example-Replacing-Vue-Resource-with-Axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  beforeCreate() {
    this.$store.dispatch('initialiseStore');
  },
  render: h => h(App),
  router,
});
